export const GrowthTrackerModalView = Object.freeze({
  CHOICE: 'choice',
  GROUP: 'group',
  SPORTER: 'sporter',
  SESSION: 'session'
});
